import React from "react";

export default function Merch() {
  return (
    <section
      id="merch"
      data-testid="merch-section"
      className="relative py-24 md:py-32 border-t border-white/5 overflow-hidden"
    >
      {/* Background glow */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[60rem] h-[60rem] rounded-full bg-[#C5A059]/[0.06] blur-3xl" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex items-end justify-between mb-14 md:mb-20 gap-6 flex-wrap">
          <div>
            <div className="flex items-center gap-4 mb-4">
              <span className="font-display text-[#C5A059] text-lg md:text-xl tracking-tight">
                Ch. 03
              </span>
              <span className="h-px w-16 bg-[#C5A059]/40" />
              <span className="text-[10px] uppercase tracking-[0.4em] text-[#C5A059]">
                Drops
              </span>
            </div>
            <h2 className="font-display uppercase font-semibold tracking-tighter text-[#F5F5F0] text-4xl md:text-6xl">
              Exclusive <span className="text-[#C5A059]">Merch</span>
            </h2>
          </div>
          <p className="max-w-sm text-sm text-[#F5F5F0]/60 leading-relaxed">
            Limited-run pieces designed and shipped straight from the studio.
            First drop launching soon.
          </p>
        </div>

        {/* Coming soon panel */}
        <div
          data-testid="merch-coming-soon"
          className="relative border border-[#C5A059]/30 bg-gradient-to-b from-[#0d0c08] to-[#070707] p-10 md:p-20 text-center overflow-hidden"
        >
          {/* corner accents */}
          <span className="absolute top-0 left-0 w-10 h-px bg-[#C5A059]" />
          <span className="absolute top-0 left-0 w-px h-10 bg-[#C5A059]" />
          <span className="absolute top-0 right-0 w-10 h-px bg-[#C5A059]" />
          <span className="absolute top-0 right-0 w-px h-10 bg-[#C5A059]" />
          <span className="absolute bottom-0 left-0 w-10 h-px bg-[#C5A059]" />
          <span className="absolute bottom-0 left-0 w-px h-10 bg-[#C5A059]" />
          <span className="absolute bottom-0 right-0 w-10 h-px bg-[#C5A059]" />
          <span className="absolute bottom-0 right-0 w-px h-10 bg-[#C5A059]" />

          <div className="inline-flex items-center gap-3 mb-6">
            <span className="h-px w-8 bg-[#C5A059]" />
            <span className="text-[10px] uppercase tracking-[0.4em] text-[#C5A059]">
              Stay Locked In
            </span>
            <span className="h-px w-8 bg-[#C5A059]" />
          </div>

          <h3 className="font-display uppercase font-bold tracking-tighter text-[#F5F5F0] text-5xl sm:text-6xl md:text-8xl leading-[0.9]">
            Coming <span className="text-[#C5A059]">Soon</span>
          </h3>

          <p className="mt-8 max-w-xl mx-auto text-sm md:text-base text-[#F5F5F0]/60 leading-relaxed">
            The first wave of BOB9INE merch is in production. Follow the socials
            below to be the first in line when it drops.
          </p>

          <a
            href="#connect"
            data-testid="merch-notify-cta"
            className="group mt-10 inline-flex items-center gap-3 border border-[#C5A059] text-[#C5A059] px-7 py-3.5 text-xs uppercase tracking-[0.3em] hover:bg-[#C5A059] hover:text-[#050505] transition-all duration-300"
          >
            Follow For Updates
            <span className="inline-block transition-transform duration-300 group-hover:translate-x-1">
              →
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}
